module.exports = __webpack_public_path__ + "img/icon-info.b8ef226e.png";